const generateUrl = (params, currentParams) => {
    // Return false if params is undefined or null
    if (!Array.isArray(params)) return false;

    let stringParams = currentParams ? "&" : "?";

    // Iterate over params and construct the query string
    params.forEach((item) => {
        if (typeof item.values === "object") {
            // Check if values is an array before iterating
            if (Array.isArray(item.values)) {
                item.values.forEach((value) => {
                    stringParams += `${item.param}=${value}&`;
                });
            }
        } else if (typeof item.values === "string") {
            stringParams += `${item.param}=${item.values}&`;
        }
    });

    // Remove the trailing '&' if present
    if (stringParams.slice(-1) === "&") {
        stringParams = stringParams.slice(0, -1);
    }

    return stringParams;
}

export default generateUrl;
